import { ActionIcon, ActionIconProps, ElementProps } from '@mantine/core';
import clsx from 'clsx';
import { useUnit } from 'effector-react';
import { ChevronLeft } from 'lucide-react';
import { forwardRef } from 'react';
import { RegistryModel, Row } from 'shared/lib';

export type RegistryPaginationControlsPreviousProps = ActionIconProps &
	ElementProps<'button', keyof ActionIconProps>;

export const createRegistryPaginationControlsPrevious = <
	TRow extends Row,
	TFilters extends Record<string, unknown>,
	TError,
>(
	model: RegistryModel<TRow, TFilters, TError>,
) => {
	const RegistryPaginationControlsPrevious = forwardRef<
		HTMLButtonElement,
		RegistryPaginationControlsPreviousProps
	>(({ className, children, onClick, ...props }, ref) => {
		const [click, disabled] = useUnit([
			model.paginationPreviousClicked,
			model.$paginationPreviousDisabled,
		]);

		return (
			<ActionIcon
				ref={ref}
				data-test-id='registry-pagination-controls-previous'
				disabled={disabled}
				variant='outline'
				size='sm'
				className={clsx('registry-pagination-controls-previous', className)}
				onClick={(event) => {
					click();
					onClick?.(event);
				}}
				{...props}
			>
				{children ?? <ChevronLeft />}
			</ActionIcon>
		);
	});

	return RegistryPaginationControlsPrevious;
};
